import { LocalKey } from "@base/constants/LocalKey";
import { baseRoutes } from "@base/routes/baseRoutes";
import { isEmpty } from "lodash";
import { createSearchParams, useLocation, useNavigate, useSearchParams } from "react-router-dom";

const useCheckLogin = (enabeld = true) => {
  const authLogin = localStorage.getItem(LocalKey.AUTH);

  const location = useLocation();
  const navigate = useNavigate();
  const [parmas] = useSearchParams();
  const redirectTo = parmas.get("redirectTo");

  const handleCheckLogin = () => {
    if (enabeld && isEmpty(authLogin)) {
      navigate(
        {
          pathname: `${baseRoutes.login}`,
          // Same shape ProtectedRoute builds, so both entry points round-trip identically.
          search: createSearchParams({
            redirectTo: `${location.pathname}${location.search}`,
          }).toString(),
        },
        { replace: true },
      );
    }
  };

  return {
    isLogin: !!authLogin,
    redirectTo,
    handleCheckLogin,
  };
};

export default useCheckLogin;
